/**
 * Los diccionarios de traducción, con LA FRASE EN ESPAÑOL COMO CLAVE.
 *
 * ---------------------------------------------------------------------------
 * POR QUÉ LA CLAVE ES LA FRASE Y NO UN NOMBRE
 *
 * La alternativa era inventar 1.094 nombres de clave —`pnl_titulo`,
 * `pnl_nota_costos`, `pnl_footnote_ebitda`…— y eso tiene tres costes que aquí
 * no compensan:
 *
 * 1. **El código deja de decir lo que dice la pantalla.** Leyendo
 *    `t("pnl_nota_costos")` no se sabe qué sale por pantalla, así que revisar
 *    un cambio de texto obliga a abrir dos archivos. Con la frase dentro, el
 *    JSX se sigue leyendo como antes.
 * 2. **Hay que inventar y mantener 1.094 nombres**, que es trabajo puro de
 *    nomenclatura con cero información nueva.
 * 3. **Un nombre mal elegido se queda para siempre**, y renombrarlo después
 *    obliga a tocar el código y los tres diccionarios a la vez.
 *
 * Es el patrón de `gettext`, que lleva treinta años resolviendo esto igual.
 *
 * ---------------------------------------------------------------------------
 * LA DEGRADACIÓN ES LO QUE LO HACE SEGURO
 *
 * Si una frase no está en el diccionario, `t()` devuelve **la propia clave**,
 * que ES el español. O sea:
 *
 *   - una traducción que falta → se ve en español, como hoy;
 *   - alguien corrige el texto español → la clave cambia, no coincide con el
 *     diccionario, y esa frase vuelve al español hasta que se retraduzca.
 *
 * Nunca hay una pantalla en blanco ni una clave cruda a la vista. Esa es la
 * propiedad que permitió hacer la migración de 1.398 cadenas de una vez.
 *
 * ---------------------------------------------------------------------------
 * LO QUE NO ESTÁ AQUÍ
 *
 * - **La terminología fiscal** (IGV, RUC, SUNAT, CNPJ): va en `TERMINOLOGIA` y
 *   sigue a la SOCIEDAD, no al lector. Son nombres legales.
 * - **La voz de Marty**: ya estaba en los tres idiomas en `lib/marty.ts`, con
 *   su propio catálogo por sección y estado.
 */
import { EN } from "@/lib/locales/en"
import { PT } from "@/lib/locales/pt"

export type Traducciones = Record<string, string>

export const DICCIONARIOS: Record<"es" | "pt" | "en", Traducciones> = {
  // El español es la clave: no hay diccionario que consultar.
  es: {},
  pt: PT,
  en: EN,
}
